module.exports = __webpack_public_path__ + "annualreview2017/static/pdfs/uk-power-network-services.2050473.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/uk-power-network-services.pdf
// module id = 647
// module chunks = 0